// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAt-Wb8AUaoyoVMcYmkOCdFSs5lFcVUnA4",
  authDomain: "seoforsmallbusinessmarch01.firebaseapp.com",
  projectId: "seoforsmallbusinessmarch01",
  storageBucket: "seoforsmallbusinessmarch01.firebasestorage.app",
  messagingSenderId: "30693922171",
  appId: "1:30693922171:web:02bd875ff7674e1bdcd9de"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;